









































































































































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { AuthModule } from '@/store/Auth/AuthModule';
import InstitutionState from '@/components/Settings/Institutions/InstitutionState.vue';

@Component({ name: 'InstitutionAccounts', components: { InstitutionState } })
export default class extends SaascadaVue {

    get institutionConfig() {
        return AuthModule.me.institution.config;
    }

    get institutionLabels() {
        return AuthModule.me.institution.config.labels;
    }

}
